import { render, staticRenderFns } from "./OrderActionsDialogs.vue?vue&type=template&id=f30cf314"
import script from "./OrderActionsDialogs.vue?vue&type=script&lang=js"
export * from "./OrderActionsDialogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports